import gql from "graphql-tag";

export const login = gql`
  mutation login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      type
      message
      details
    }
  }
`;

export const resetPassword = gql`
  mutation resetPassword($email: String!) {
    resetPassword(email: $email) {
      type
      message
      details
    }
  }
`;

export const setNewPasswordFromRequest = gql`
  mutation setNewPasswordFromRequest(
    $newPassword: String!
    $requestCode: String!
  ) {
    setNewPasswordFromRequest(
      newPassword: $newPassword
      requestCode: $requestCode
    ) {
      type
      message
      details
    }
  }
`;

export const validate = gql`
  mutation validate($validationToken: String!, $validationCode: String!) {
    validate(
      validationToken: $validationToken
      validationCode: $validationCode
    ) {
      type
      message
      details
    }
  }
`;

export const register = gql`
  mutation register(
    $firstName: String!
    $lastName: String!
    $email: String!
    $password: String!
    $denomination: String!
    $siren: String
    $codePostal: String!
    $ville: String!
    $pays: String!
    $adresse: String!
    $adresseComplement: String
    $phone: String
  ) {
    register(
      firstName: $firstName
      lastName: $lastName
      email: $email
      password: $password
      denomination: $denomination
      siren: $siren
      codePostal: $codePostal
      ville: $ville
      pays: $pays
      adresse: $adresse
      adresseComplement: $adresseComplement
      phone: $phone
    ) {
      type
      message
      details
    }
  }
`;

export const preRegister = gql`
  mutation preRegister($email: String!) {
    preRegister(email: $email) {
      type
      message
      details
    }
  }
`;

export const updateUser = gql`
  mutation updateUser(
    $id: Int!
    $firstName: String!
    $lastName: String!
    $email: String!
    $password: String!
    $phone: String
  ) {
    updateUser(
      id: $id
      firstName: $firstName
      lastName: $lastName
      email: $email
      password: $password
      phone: $phone
    ) {
      type
      message
      details
    }
  }
`;

export const updatePassword = gql`
  mutation updatePassword(
    $id: Int!
    $oldPassword: String!
    $newPassword: String!
  ) {
    updatePassword(
      id: $id
      oldPassword: $oldPassword
      newPassword: $newPassword
    ) {
      type
      message
      details
    }
  }
`;
